import { useRequestContext } from '@coolblue-development/next-request-context/client';
export default function useTestId(id) {
    const { isInternalUser } = useRequestContext();
    const testId = isInternalUser ? id : undefined;
    return {
        'data-cy': testId,
        'data-testid': testId,
    };
}
//# sourceMappingURL=useTestId.js.map